import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Dropdown, Flex } from '@/lib/v2/components';
import { DropdownItemProps } from '@/lib/v2/components/Dropdown';

import { useFeatureFlag } from '@/src/application/hooks/util/useFeatureFlag';

const ActionButtons = ({ toggleModal }: { toggleModal: () => void }) => {
  const { t } = useTranslation();
  const showLogCampaign = useFeatureFlag('activityLogCampaign');

  const listDropdownActions: DropdownItemProps[] = useMemo(() => {
    return [
      {
        id: 'edit-campaign',
        value: 'edit-campaign',
        label: t('CAMPAIGN_ACTIONS_MAIN.HEADER.DROPDOWN.edit'),
        onClick: toggleModal,
      },
      {
        id: 'delete-campaign',
        value: 'delete-campaign',
        label: t('CAMPAIGN_ACTIONS_MAIN.HEADER.DROPDOWN.delete'),
        onClick: () => console.log('Onclick'),
      },
    ];
  }, [t, toggleModal]);

  return (
    <Flex withGap alignment="end" gapSize="small">
      {showLogCampaign && (
        <Button outline id="log-actions-button" size="medium" onClick={() => alert('Activity log')}>
          {t('CAMPAIGN_ACTIONS_MAIN.HEADER.log')}
        </Button>
      )}
      <Dropdown
        menuOnTheLeft
        color="primary"
        dropdownItems={listDropdownActions}
        id="options-actions-dropdown"
        label={t('CAMPAIGN_ACTIONS_MAIN.HEADER.options')}
      />
    </Flex>
  );
};

export default memo(ActionButtons);
